/**
 * Routes where the username-email safety modal should not be shown to avoid
 * checkout conversion friction. Patterns allow an optional 2-letter locale
 * prefix (e.g. `/gb/bag`) because `usePathname()` includes it for non-default
 * locales.
 */
export const EXCLUDED_ROUTES: readonly RegExp[] = [
  /^(?:\/[a-z]{2})?\/bag\/?$/,
  /^(?:\/[a-z]{2})?\/pay(\/.*)?$/,
  /^(?:\/[a-z]{2})?\/purchases(\/.*)?$/,
];

/**
 * Storage-key version. Bumped to `v2` for WEB-9016 so users who dismissed the
 * v1 modal see the refreshed modal again; dismissing it writes the v2 key,
 * which suppresses it thereafter. The orphaned v1 key is harmless.
 */
export const USERNAME_EMAIL_SAFETY_PROMPT_SEEN_KEY_PREFIX =
  'usernameEmailSafetyPromptSeen:v2:';

export function getUsernameEmailSafetyPromptStorageKey(userId: number): string {
  return `${USERNAME_EMAIL_SAFETY_PROMPT_SEEN_KEY_PREFIX}${userId}`;
}
